import { useSoftwareVersion } from 'src/Libs/home-power-station'
import { useTypedSelector } from 'src/State/RootReducer'
import { getSupportedSoftwareVersionsDynamicPowerPrices } from '../utils/price-settings'
import { useFetchTariffsMode } from 'src/Libs/ai-360/hooks'
import { useFetchDynamicPowerPrice } from './use-fetch-dynamic-power-price'
import type { UseCheckDynamicPowerPriceApplicability } from '../types'

/**
 * hook which shares if dynamic power prices are enabled or applicable
 *
 * @param storageId
 * @returns
 */
const useCheckDynamicPowerPriceApplicability = (storageId: string): UseCheckDynamicPowerPriceApplicability => {
  const installationId = useTypedSelector(state => state.storage.installation?.id)
  const { softwareVersion } = useSoftwareVersion()
  const { doesSupportFullVersion, doesSupportMinimumVersion, doesSupportFullVersionOnlyGermany } =
    getSupportedSoftwareVersionsDynamicPowerPrices(softwareVersion)
  const shouldFetchDynamicPowerPrice = doesSupportFullVersion || doesSupportMinimumVersion || doesSupportFullVersionOnlyGermany
  const {
    dynamicPowerPrices: dynamicPriceSettingsData,
    isError: isDynamicPriceSettingsError,
    isLoading: isDynamicPriceSettingsLoading,
  } = useFetchDynamicPowerPrice(storageId, shouldFetchDynamicPowerPrice)
  const { tariffsMode } = useFetchTariffsMode(installationId)

  if (isDynamicPriceSettingsError || !dynamicPriceSettingsData) {
    return {
      isDynamicPowerPriceEnabled: false,
      isDynamicPowerPriceEnabledForWallboxes: false,
      isDynamicPowerPriceEnabledForBattery: false,
      isDynamicPowerPriceLoading: false,
    }
  }

  return {
    isDynamicPowerPriceEnabledForWallboxes: dynamicPriceSettingsData?.dynamicPricesForWallboxesEnabled || false,
    isDynamicPowerPriceEnabledForBattery: dynamicPriceSettingsData?.dynamicPricesForBatteryEnabled || false,
    isDynamicPowerPriceEnabled:
      tariffsMode?.mode === 'STATIC'
        ? false
        : !!dynamicPriceSettingsData?.dynamicPricesForWallboxesEnabled || !!dynamicPriceSettingsData?.dynamicPricesForBatteryEnabled,
    isDynamicPowerPriceLoading: isDynamicPriceSettingsLoading,
  }
}

export default useCheckDynamicPowerPriceApplicability
